export default {
  zh: {
    1001: '地址不可用，请修改后重试',
    1002: '订单下的商品不存在',
    1003: '部分商品未关联采购链接',
    1004: '店铺默认物流方式未设置',
    1005: '钱包余额不足',
    1006: '商品库存不足',
    1007: '请选择附加项',
    1008: 'D2C直发订单商品金额超过2000元',
    1010: '物流公司不存在货代公司',
    1011: '物流公司不支持该国家发货',
    1012: '国家信息错误，请编辑收件信息',
    1013: '详细地址不能超过40个字符',
    1015: '物流系统不存在',
    10000: '快递已签收',
    10001: '未查询到包裹信息',
    10002: '当前批次包已有移库单',
    10003: '未查到可处理移库单',
    10004: '可用批次包总数不足',
    10005: '批次包不存在',
    10006: '商品库存不存在',
    10007: '内部异常不存在',
    10008: '入库数超过采购总数',
    10009: '成品不可移库',
    10013: '移库单不存在或已处理',
    10019: '当前仓库不可操作此包裹',
    10020: '图片数量超过5张',
    10021: '库区不可编辑',
    2500009: '超级管理员admin用户不能被删除',
    10000000: '请重新登录',
    10000001: '服务异常',
    20000000: '当前订单正在处理中，请勿重复操作',
    20000005: '商品库存不足',
    20001075: '物流不支持此区域',
    20001076: '物流区域报价不匹配',
    21190002: '处理中，请勿重复操作',
    22010002: '钱包余额不足',
    22010003: '单笔订单价值不得超过2000元，请调整商品数量',
    22010056: 'API订单下单失败：寻源单销售价格为空',
    22010071: '组合商品库存不足，下单失败',
    22010079: 'API订单下单失败：会员等级不足',
    22010081: 'API下单失败：关联商品已下架',
    22010084: 'API下单失败：关联商品已失效',
    22010092: 'OEM库存不足，下单失败',
    25000001: '用户名或者密码错误',
    25000002: '密码错误',
    25000003: '用户被禁用',
    25000004: '号码已存在',
    25000005: '号码格式不正确',
    25000006: '当前用户不是主管',
    25000007: '用户已存在',
    25000008: '用户未分配角色！',
    25000012: '30分钟内密码错误5次',
    25010001: '角色只能添加在公司下',
    25010002: '角色id不能为空',
    25010003: '用户包含该角色',
    25010004: '角色名称已存在',
    25010005: '角色不存在',
    25010006: '角色不能删除',
    25010007: '当前角色名称不支持更新',
    25010008: '角色更新失败！',
    25020001: '菜单id不能为空',
    25020002: '菜单功能编码重复',
    25040009: '原密码错误',
    26000000: 'WMS服务异常',
    26000001: '参数错误',
    26000002: '未知错误',
    26000003: '更新失败',
    26000004: '系统繁忙，请稍后重试',
    26000006: '发货订单未支付国际发货费用',
    26000007: '发货订单支付国际发货费用进行中',
    26000008: '发货任务不存在此商品sku',
    26000009: '获取发货任务地址信息为空',
    26000010: '未匹配运费配置，请联系财务',
    26000011: '获取用户登录信息异常',
    26000012: '释放分拣框使用状态失败',
    26000013: '获取发货装箱信息失败',
    26000014: '获取发货装箱信息为空',
    26000015: '获取发货装箱信息失败',
    26000016: '当前箱子重量超上限',
    26000017: '当前容器重量超上限',
    26000018: '当前容器的商品金额超上限',
    26000019: '商品已装箱数量超过总数量',
    26000020: '获取发货-拣货任务信息为空',
    26000021: '更新发货-拣货任务状态失败',
    26000022: '发货-拣货任务存在未拣的数据',
    26000023: '获取发货-拣货任务处理器为空',
    26000024: '更新发货任务配货详情状态失败',
    26000025: '获取发货任务配货详情信息为空',
    26000026: '该商品库存当前被其它拣货任务所占用,请稍等',
    26000027: '获取用户钱包数据为空',
    26000028: '用户余额不足',
    26000030: '该分拣框编号已存在，请修改',
    26000031: '容器编码不能为空',
    26000060: '当前物流状态不允许取消',
    26000061: '获取发货任务附加项详情信息为空',
    26000062: '模板名已存在',
    26000063: '大件打包已完成不能修改物流公司',
    26000064: '货代公司不可用',
    26000066: '非打包完成状态不能操作',
    26000067: '物流单号不能为空',
    26000072: '不支持的物流公司，请重新选择或手工输入运单号',
    26000074: '发件人信息为空',
    26000075: '收件人信息为空',
    26000078: '获取物流单号失败{0}',
    26000079: '未选择渠道运输方式',
    26000089: '未装箱',
    26000090: '未对接API类型的物流公司，请更换物流或手工输入运单号',
    26000091: '获取rmb->日元汇率失败',
    26000092: '获取rmb->美元汇率失败',
    26000095: '线下类型物流公司，无法获取物流轨迹',
    26000096: '未查询到物流单号',
    26000097: '运输方式不属于该物流公司，请重新选择',
    26000098: '发货任务编号不能为空',
    26000099: '所选货代公司未配置物流API类型，请前往：配置->物流API关联配置页面操作',
    26000103: '发货任务已存在',
    26000104: '参数为空',
    26000105: '物流单号为空不允许发货',
    26000106: '勾选发货单数不能超过分拣框总数{0}',
    26000107: '分配分拣框异常',
    26000108: '不存在该SKU',
    26000109: '更新失败',
    26000110: '商品数量溢出',
    26000111: '分拣数不能超过可分拣数',
    26000112: '修改审单货代公司失败{0}',
    26000113: '未拣货不能打标',
    26000114: '发货任务状态不是打包中',
    26000115: '支付结果通知:支付状态不是支付成功或失败!',
    26000116: '同步辅料库存异常{0}',
    26000117: '填写发货信息失败:{0}',
    26000120: '获取用户钱包失败',
    26000122: '批量发货异常：{0}',
    26000125: '直发多品批次包不可操作',
    26000127: '未查询到可用批次包',
    26000129: '收获地址不可为空',
    26000130: '收获地址的国家不能为空',
    26000131: '收获地址的国家非日本，不可获取面单',
    26000132: '审核明细未找到',
    26000133: '箱子重量为0不能发货',
    26000134: '请删除空箱子',
    26000135: '拦截包裹',
    26000136: '余额不足',
    26000137: '未找到需要确认的国际发货单',
    26010002: '批次包信息不存在',
    26010008: '次品及异常不允许移库至成品区',
    26010014: '调拨单编码为空',
    26010015: '运单号为空',
    26010017: '导出数量超过50000，请添加筛选条件',
    26010018: '批次状态变化',
    26010019: '部分批次包类型已发生改变，不能移库至该库区，请驳回这部分批次包：{0}',
    26010023: '存在移库单未确认，请在确认移库后上架',
    26010024: '批次无体积，请编辑体积后上架{0}',
    26010029: '批次包上架失败，批次包【{0}】发货完成，禁止上架',
    26020001: '发货任务已存在',
    26020002: '发货任务不存在',
    26020003: '更新发货任务数据失败',
    26020004: '获取发货任务信息为空',
    26020005: '请选择正确的发货单号',
    26020006: '仓库已开始作业，不允许修改',
    26020010: '商品未全部打包',
    26020011: '包裹重量不能为0',
    26020012: '钱包服务异常',
    26020013: '拣货数量异常',
    26020014: '国际发货操作记录不存在',
    26020015: '结算操作记录不存在',
    26020016: '已发货才允许重新生成物流单号',
    26020017: '获取物流单号失败{0}',
    26020019: '部分单据未拣货完成，无法确认发货：{0}',
    26020020: '未找到发货单收货地址',
    26020023: '发货单数据发生变化，请刷新后操作',
    26020024: '发货单已取消',
    26020025: '发货单已确认',
    26020029: '未查询到该物流单号下的商品',
    26020030: '发货单抵扣数量异常',
    26020031: '抵扣数据异常',
    26020032: '国际发货单不支持取消',
    26020033: '发货单状态未打包完成',
    26020034: '发货单缺少标签信息',
    26020035: '发货单标签信息异常',
    26020038: '未找到满足打包条件的发货单',
    26020042: '获取汇率异常',
    26020043: '该币种不支持',
    26020048: '物流单号不可重复',
    26030001: 'excel出现错误的标题',
    26030004: '商品库存数据不存在',
    26030005: '冻结库存业务编码已存在',
    26030006: '可用库存不足',
    26030007: '成品库存数据异常',
    26030008: '库存已冻结',
    26040001: '容器编号已存在',
    26040002: '容器编号不存在',
    26040003: '容器编号16字符以内',
    26040004: '容器编号需首字母大写',
    26040005: '该容器不可关闭',
    26040006: '分拣子容器不能为空',
    26040007: '分拣子容器数量不足',
    26040008: '容器使用中禁止关闭',
    26040009: '容器正在使用中，请使用其他容器',
    26040010: '拣货容器使用中未达到解绑状态',
    26040011: '该容器已经绑定其他批次',
    26040012: '容器非拣货容器',
    26040013: '容器非分拣容器',
    26040014: '分拣子容器禁止绑定',
    26040015: '容器已经关闭',
    26040016: '该容器未进行绑定',
    26040017: '选择的拣货任务已经开始拣货，请重新选择拣货任务',
    26040018: '操作容器状态异常',
    26040019: '该该容器已经在分拣',
    26040020: '未找到任务批次',
    26040021: '该容器已经绑定了其他人',
    26040022: '该容器未绑定批次',
    26040023: '该容器已经绑定其他批次',
    26040025: '您已绑定其他分拣容器',
    26040026: '您已绑定其他拣货容器',
    26040027: '该库位存在待处理的异常包裹',
    26040028: '该子容器未找到商品',
    26040029: '超过分拣容器最大数量限制',
    26040030: '该批次已经绑定其他容器',
    26040031: '该容器暂不支持分拣',
    26040032: '该批次已经开始拣货',
    26040033: '该容器不支持解绑',
    26040034: '该容器不是分拣子容器',
    26040035: '只有打包中或待打包分拣容器可以提交异常',
    26040036: '该容器已经绑定',
    26040037: '拣货子容器未找到',
    26060001: '发货审单已存在',
    26060002: '发货审单不存在',
    26060005: '已完成审单，无需重复审核',
    26060006: '发货单已取消，无需审单',
    26060007: '除此单，该类型下暂无需要审核单据',
    26060009: '商品信息不存在',
    26060010: '此收货国家可用的货代公司有变更，请刷新页面',
    26060011: '审单状态已经是待确认或已处理状态,不允许进行异常变更',
    26060012: '审核单已经确认',
    26060013: '审核单状态已经改变',
    26060014: '商品运输属性无对应异常原因，请重新确认',
    26090001: '配置已存在',
    26090002: '配置不存在',
    26090003: '配置已存在，请查找并编辑',
    26090004: '一台电脑仅可配置一台相同尺寸打印机',
    26090005: '分拣框超过上限',
    26090006: '库位未找到',
    26090007: '模板配置数据缺失',
    26090008: '模板配置排序重复',
    26100001: '入库单创建失败',
    26100006: '入库单采购信息不存在',
    26100008: '少件异常处理量超过剩余可处理量',
    26100009: '入库数量未达到采购需求数量,禁止发起多件请求',
    26100011: '发起少件失败',
    26100013: '入库单未签收,请进行签收',
    26100016: '未找到该单号异常记录',
    26100017: '请选择程度',
    26100018: '程度编码异常',
    26100019: '该商品未完成入库不允许发起多件入库',
    26100022: '关联少件异常不存在',
    26100023: '入库数量超限或已完成',
    26100024: '箱唛号重复，请扫描物流单号',
    26110001: '业务已处理，不可更改图片',
    26110002: '非法传入事件类型值',
    26110003: '非法传入事件类型值,无法转换为状态',
    26110004: '事件id不能为空',
    26110005: '非法传入拦截状态值,无法转换为状态',
    26110006: '该发货单已被拦截，请单独放置',
    26110007: '该发货单已被拦截，无法生成拣货任务',
    26110008: '审单原因不在指定范围内',
    26140002: '调整后数量不能等于原数量',
    26150001: '货代不一致，请刷新',
    26150002: '存在已打包完成的发货单，请刷新页面数据',
    26160001: '入库单号错误',
    26160002: '需要重新贴标，请在电脑上进行入库操作',
    26160003: '以下商品需要重新贴标，请在电脑上进行入库操作:{0}',
    26160004: '当前库区无待移库的商品',
    26160005: '已签收的入库单不能取消',
    26160009: '入库单未签收',
    26160010: '同商品状态下只能存在一个库区',
    26170001: '商品数据重复',
    26170002: '商品数据信息不全',
    26170004: 'SKU编码重复',
    26170005: '文件行数超过{0}行限制',
    26170006: '不支持的文件格式，支持：txt, csv, xls, xlsx',
    26170007: '运单号已被使用，不能删除',
    26170011: '所有入库单都已入库完成',
    26170012: '该sku已全部上架，请扫描其他sku',
    26170014: '请填写厚度和三边和',
    26170015: '发货单已扣运费，不可更改运单号',
    27000000: '库存变更失败',
    27000001: '可用库存不足',
    27000002: '操作类型异常',
    27000003: '不支持该操作类型',
    27000004: '未找到对应库存',
    27000005: '库存容器或货位不能为空',
    27000006: '库存加锁服务异常',
    28010010: '物流系统不存在',
    220101012: '发货单确认失败',
    220101015: '订单未审单完成，暂时无法优先发货',
    220101019: '存在未授权的品牌商品',
    240000012: '黑名单商品不支持下单',
    240000014: 'API下单失败，不满足最小起订量，需手动下单',
    240000015: '批量有限发货超过限制,限制200',
    240000016: '所选订单无法优先发货',
    240000017: '已经存在提前发货任务',
    260000000: '创建发货任务参数无效',
    260000001: '更新发货任务状态失败',
    260000002: '更新发货任务数据失败',
    260000003: '获取发货任务信息为空',
    260000110: '分拣框未使用数不够分配',
    260001391: '国际发货单与结算币种不一致',
    '-1': 'エラーあり カスタマーサービスへご連絡下さい',
    '26010019-1': '部分批次包不能移库到该库区，已从页面上取消这部分批次包：{0}',
    '26040001-1': '容器前缀已存在',
    '10008_1': '入库数超过入库单商品总数',
    '-3': '发货任务编号不能为空',
    '26000010-1': '运单号{0}计算所得运费为0，请联系财务',
    '26000010-2': '校验运费规则异常：{0}',
    '26000017-1': '当前包裹重量超上限',
    '26000018-1': '当前箱子的商品金额超上限',
    '26000018-2': '当前包裹的商品金额超上限',
    '26000025-1': '异常货位有多个国际发货单,数据异常',
    '26000064-1': '{0}货代公司不可用',
    '26000064-2': '一价全包订单不可修改物流',
    '26000075_1': '清关地址信息为空',
    '26000099-1': '所选{0}货代公司未配置物流API类型，请前往：配置->物流API关联配置页面操作',
    '26000099-2': '所选货代公司未配置对应的国际运费规则，请选择其他渠道或联系财务配置',
    '26000099-3': '所选货代公司:{0},未配置对应的国际运费规则，请选择其他渠道或联系财务配置',
    '26000134-1': '未找到对应物流单号',
    '26000137-1': '客户id为空',
    '26020031-1': '长宽高限制[1~1000]cm',
    '26040021-1': '当前用户绑定多个拣货容器,请先解绑',
    '26040021-2': '当前用户已绑定容器:{0}',
    '26040021-3': '该批次已经绑定其他容器:{0}',
    '26060013-1': '审核单已经被取消,请刷新页面',
    '26060013-2': '审核单部分SKU已经被取消,请刷新页面',
    20000018: 'API下单全部失败，商品有异常',
    20000019: 'API下单部分失败，商品有异常',
    26170008: '仅支持日本邮政',
    26170009: '无可使用的运单号',
    26170010: '获取荷物仕分番号失败',
    26170013: '格式错误，包含特殊字符'
  },
  ja: {
    0: '正常',
    101: '相違品',
    102: '数量不足',
    103: '複数件',
    104: '追跡番号がスキャンできない',
    105: '部分商品到着済み',
    201: '色相違',
    202: '商品に中国語表記あり',
    203: '付属品の違い（ポケット、ベルト、ボタン、ファスナー、紐など）',
    204: 'ロゴの違い',
    205: 'サイズ違い',
    206: 'デザインの違い（ステッチ、襟口、袖口、柄、衣服デザインなど）',
    207: '素材・生地の違い',
    301: '色収差',
    302: '汚れ／シミ／水跡',
    303: '破損',
    304: '糸ほつれ',
    305: '縫い目不良',
    306: 'ほつれ',
    307: '針の穴',
    308: 'カビ',
    309: '錆',
    310: '商品に中国語表記あり',
    311: 'ボタン破損',
    312: 'ファスナー破損',
    313: '付属品の欠陥',
    314: '臭いあり',
    315: 'その他不良',
    316: '通電不良',
    1001: '住所不備、修正後に再試行してください',
    1002: '注文内の商品が存在しません',
    1003: 'THE CKB商品と紐付けない商品があります',
    1004: '発注不可，運送会社設定実施後、発注可能',
    1005: '該当店舗の口座残高不足，資金をチャージ後、発注をお願いします',
    1006: '在庫不足商品があります',
    1007: '商品オプションをご選択下さい',
    1008: '注文上限額超過，D2C直送の注文合計額上限は、2000元/回　です',
    1010: 'お届け先国に選択可能な配送ルートがありません<br/>カスタマサービスにお問い合わせください',
    1011: '対象国への配送はサポートしていません',
    1012: 'お届け先情報不備：【国】を修正する必要があります',
    1013: '詳細住所は40文字以内で入力してください',
    1014: 'この注文には日本円価格商品が含まれており、APIで注文できません。ご確認の上、改めて紐づけてからご注文ください',
    1015: 'システム内に該当する物流情報が存在しません',
    8000: 'ご契約のプランでは、この配送方法に対応できません。配送方法を変更してから費用を確認して下さい',
    8001: 'ご契約のプランでは、このオプションを対応できません',
    8002: '重量を満たさません（>Xkg）',
    8003: '発送できる重量を超過しています（＜Xkg）',
    8005: '取扱商品の種類が複数あるため、分割発送する可能性があります',
    8006: 'この運送会社では、X を発送対応できません',
    10000: '受領済み',
    10001: '荷物の追跡が見つかりません',
    10002: '該当ロットには移庫伝票が既に存在します',
    10003: '処理可能な移庫伝票が見つかりません',
    10004: '利用可能なロットの総数が不足しています',
    10005: 'このロットが存在しません',
    10006: '商品在庫が存在しません',
    10007: '内部エラーが存在しません',
    10008: '入庫数が仕入総数を超えています',
    10009: '料品が移庫できません',
    10013: '移庫伝票が存在しないか、すでに処理されたかもしれません',
    10019: '該当荷物操作不可',
    10020: '画像が5枚超えます',
    10021: '庫区編集不可',
    100021: '这个的翻译 제3자 플랫폼 로그인 인증 실패',
    2500009: 'システム管理者(admin)アカウントは削除不可です',
    10000000: '再度ログインしてください。',
    10000001: 'サーバー異常',
    20000000: 'この注文は処理中です。重複操作はしないでください',
    20000005: '商品在庫不足',
    20001075: 'この地域は物流対象外です。',
    20001076: '物流エリアの料金が一致しません',
    21190002: '処理中です。重複操作はしないでください',
    22010000: 'システムエラーが発生しました。',
    22010002: '残高不足口座残高をチャージして下さい',
    22010003: '注文上限額超過，D2C直送の注文合計額上限は、2000元/回　です',
    22010056: 'エラーが発生しました<br/>カスタマサービスにご連絡ください',
    22010071: '在庫不足で直送注文の発注に失敗しました、組合せ商品は先に在庫保有注文をご発注下さい',
    22010079: '発注不可：未登録状態であり、会員登録をして下さい',
    22010081: '発注不可：在庫切れ',
    22010084: '発注不可：URL切れ',
    22010092: 'OEM在庫不足のため、発注できません',
    22040020: '商品のMSKUが未入力です。',
    22041027: '同じAmazon skuを持つ、違う仕入れ先から仕入れた商品があります。 新規納品プランを作成し、重複している商品を分割発送してください',
    25000001: 'ユーザー名またはパスワードが正しくありません',
    25000002: 'パスワードが正しくありません',
    25000003: 'アカウントが無効化されています',
    25000004: 'この電話番号は既に登録されています',
    25000005: '正しい番号形式で入力してください',
    25000006: '操作権限がありません（管理者限定）',
    25000007: 'ユーザー重複',
    25000008: 'このユーザーにはロールが設定されていません',
    25000011: 'パスワードは少なくとも6文字以上が必要です',
    25000012: '30 分以内にパスワードを 5 回間違えた場合は、メールアドレスを使用してログインしてください。',
    25010001: 'ロールは会社単位でのみ追加可能です',
    25010002: 'ロールIDは必須入力項目です',
    25010003: 'ロール重複割り当て',
    25010004: 'ロール名重複',
    25010005: 'ロールが存在しません',
    25010006: 'ロールは削除できません',
    25010007: '現在のロール名は更新できません',
    25010008: 'ロール更新に失敗しました',
    25020001: 'メニューIDは必須項目です',
    25020002: 'メニュー機能コードが重複しています',
    25040009: '現在のパスワードが正しくありません',
    26000000: 'WMSサーバー異常',
    26000001: 'パラメータエラー',
    26000002: '不明なエラー',
    26000003: '更新失敗',
    26000004: 'システムが混雑しています。後ほど再試行してください。',
    26000006: '出荷注文は国際発送費用が未払い',
    26000007: '出荷注文の国際発送費用の支払いが進行中',
    26000008: '出荷タスクにこの商品SKUは不存在',
    26000009: '出荷タスクの住所情報なし',
    26000010: '運賃設定が未適用です。経理担当にご連絡ください',
    26000011: 'ユーザーログイン情報の取得に異常が発生しました',
    26000012: '仕分けボックスの使用状態解除失敗',
    26000013: '出荷の梱包情報取得失敗',
    26000014: '出荷の梱包情報の取得なし',
    26000015: '出荷の梱包情報取得失敗',
    26000016: '当の箱の重量が上限を超過する',
    26000017: '当のコンテナの重量が上限を超過する',
    26000018: '当のコンテナの商品金額が上限を超過する',
    26000019: '商品の梱包数が総数を超過する',
    26000020: '出荷・ピッキングタスク情報なし',
    26000021: '出荷・ピッキングタスクの状態更新失敗',
    26000022: '出荷・ピッキングタスクに未ピッキングのデータがある',
    26000023: '出荷・ピッキングタスクプロセッサ情報なし',
    26000024: '出荷タスクの配達詳細状態更新失敗',
    26000025: '出荷タスクの配達詳細情報なし',
    26000026: 'この商品の在庫は現在、他のピッキングタスクによって占有されています。少々お待ちください。',
    26000027: 'ユーザーのウォレットデータなし',
    26000028: 'ユーザー残高不足',
    26000030: 'この仕分けボックス番号は既に存在しています。番号を変更してください',
    26000031: 'コンテナID未入力（必須）',
    26000060: '現在の物流状態ではキャンセル不可',
    26000061: '出荷タスクの追加項目詳細情報なし',
    26000062: 'テンプレート名重複',
    26000063: '大型品梱包完了後：運送会社変更不可',
    26000064: 'フォワーダー利用不可',
    26000066: '梱包未完了状態で操作できない',
    26000067: '物流追跡番号必須入力',
    26000072: '非対応物流会社です。再選択するか、運送伝票番号を手動で入力してください',
    26000074: '差出人情報なし',
    26000075: '受取人情報なし',
    26000078: '物流追跡番号取得失敗{0}',
    26000079: '配送チャネル未選択',
    26000089: '未梱包',
    26000090: 'APIタイプに対応していない物流会社です。物流を変更するか、運送伝票番号を手動で入力してください',
    26000091: 'RMBからJPYへの為替レート取得失敗',
    26000092: 'RMBからUSDへの為替レート取得失敗',
    26000095: 'オフラインタイプの物流会社では、物流追跡情報を取得できない',
    26000096: '物流伝票番号が見つからない',
    26000097: '輸送方法はこの物流会社に属していません。再選択してください',
    26000098: '出荷タスク番号必須入力',
    26000099: '選択フォワーダーは物流APIタイプが設定されていません。(移動先：設定 -> 物流API関連設定ページ)',
    26000103: '出荷タスクは既に存在する',
    26000104: 'パラメータなし',
    26000105: '物流追跡番号なし、出荷不可',
    26000106: '選択出荷伝票数は、仕分けボックスの総数{0}を超えてはいけません',
    26000107: '仕分けボックス割当異常',
    26000108: '該当SKU不存在',
    26000109: '更新失敗',
    26000110: '商品数量オーバーフロー',
    26000111: '仕分け数は可仕分け数を超過不可',
    26000112: '審査フォワーダー変更失敗：{0}',
    26000113: 'ピッキングが未完了場合、ラベルを貼れない',
    26000114: '出荷指示ステータス≠梱包中',
    26000115: '支払い結果通知：支払い状態が「支払い成功」または「支払い失敗」ではない！',
    26000116: '副資材在庫の同期異常 {0}',
    26000117: '出荷情報入力失敗：{0}',
    26000120: 'ユーザーウォレット取得失敗',
    26000122: '一括出荷異常：{0}',
    26000125: '直送の複数商品バッチパッケージ操作不可',
    26000127: '使用可能なバッチパッケージが見つからない',
    26000129: '受取住所は必須入力',
    26000130: '受取住所の国名必須入力',
    26000131: '受取住所の国が日本でない場合、物流伝票を取得できない',
    26000132: '審査明細が見つからない',
    26000133: '箱の重量が0の場合、出荷できない',
    26000134: '空の箱を削除してください',
    26000135: '荷物をせき止める',
    26000136: '残高不足',
    26000137: '確認すべき国際出荷伝票が見つからない',
    26010002: '該当ロットなし',
    26010008: '不良品及び異常品は良品エリアに移動できません',
    26010014: '転送指示書のコードが空白です',
    26010015: '運送状番号が空です',
    26010017: 'エクスポート数量が50000を超えました。フィルター条件を追加してください。',
    26010018: 'ロットステータス変更',
    26010019: '一部のロットタイプが変更されましたので、該当倉庫エリアに移動できません。以下ロットを拒否してください：{0}',
    26010023: '未確認の移庫要求がありますので、移庫操作を確認してから棚上げしてください。',
    26010024: '該当ロットには容積データがありませんので、容積を入力してから棚上げしてください。{0}。',
    26010029: '該当ロット出荷完了、棚上げ禁止',
    26010033: '顧客SKUコードは必須です（空欄不可）',
    26010034: '倉庫エリアコードは必須です（空欄不可）',
    26020001: '出荷タスクは既に存在する',
    26020002: '出荷タスクが存在しない',
    26020003: '出荷タスクのデータ更新失敗',
    26020004: '出荷情報取得不可：データなし',
    26020005: '正しい出荷伝票番号を選択してください',
    26020006: '倉庫が作業を開始しているため、変更不可',
    26020010: '商品がすべて梱包されていない',
    26020011: '荷物の重量は0にできない',
    26020012: 'ウォレットサービス異常',
    26020013: 'ピッキング数量異常',
    26020014: '国際出荷操作記録が存在しない',
    26020015: '決済操作記録が存在しない',
    26020016: '出荷済みの場合のみ、物流伝票番号を再生成できる',
    26020017: '物流追跡番号取得失敗{0}',
    26020019: '一部の伝票がピッキング未完了のため、出荷確認不可：{0}',
    26020020: '出荷伝票の受取住所が見つからない',
    26020023: '出荷伝票データが変更されました。リフレッシュ後に操作してください',
    26020024: '出荷伝票はキャンセルされた',
    26020025: '出荷伝票は確認済み',
    26020029: 'この物流追跡番号に該当する商品が見つからない',
    26020030: '出荷伝票の控除数量異常',
    26020031: '控除データ異常',
    26020032: '国際出荷伝票はキャンセル不可',
    26020033: '出荷伝票の状態が梱包完了していない',
    26020034: '出荷伝票ラベル情報不足',
    26020035: '出荷伝票ラベル情報異常',
    26020038: '梱包条件を満たす出荷伝票が見つからない',
    26020042: '為替レート取得異常',
    26020043: '該当通貨非対応',
    26020048: '送り状番号重複禁止',
    26030001: 'Excelに無効なタイトルが表示されています',
    26030004: '商品の在庫データが存在しない',
    26030005: '凍結在庫の業務コードが既に存在する',
    26030006: '利用可能な在庫不足',
    26030007: '製品在庫データ異常',
    26030008: '在庫は凍結されている',
    26040001: 'コンテナ番号はすでに存在する',
    26040002: 'コンテナ番号が存在しない',
    26040003: 'コンテナ番号は16文字以内',
    26040004: 'コンテナ番号は頭文字が大文字でなければならない',
    26040005: 'このコンテナは閉じることができない',
    26040006: '仕分け用サブコンテナはブランクにできない',
    26040007: '仕分けサブコンテナ数不足',
    26040008: '使用中のコンテナは閉じることができない',
    26040009: 'コンテナは現在使用中なので、別のコンテナを使ってください',
    26040010: 'ピッキングコンテナは使用中で、アンバインド状態に達していない',
    26040011: 'このコンテナは他のバッチにバインドされている',
    26040012: 'コンテナはピッキングコンテナではない',
    26040013: 'コンテナは仕分けコンテナではない',
    26040014: '仕分け用サブコンテナはバインドできない',
    26040015: 'コンテナはすでに閉じている',
    26040016: '当のコンテナはまだバインドされていない',
    26040017: '選択したピッキングタスクはすでにピッキングを開始しています。別のピッキングタスクを選んでください',
    26040018: 'コンテナステータス操作異常',
    26040019: '当のコンテナはすでに仕分け中',
    26040020: 'タスクバッチが見つからない',
    26040021: 'このコンテナは他ユーザーにバインドされている',
    26040022: 'このコンテナはバッチにバインドされていない',
    26040023: 'このコンテナは他のバッチにバインドされている',
    26040025: 'ユーザーはすでに他の仕分けコンテナをバインドしている',
    26040026: 'ユーザーはすでに他のピッキングコンテナをバインドしている',
    26040027: 'このロケーションには処理待ちの異常な荷物がある',
    26040028: 'このサブコンテナには商品が見つからない',
    26040029: '仕分けコンテナの最大数量制限を超えている',
    26040030: 'このバッチは他のコンテナにバインドされている',
    26040031: 'このコンテナは仕分け非対応',
    26040032: 'このバッチはすでにピッキングを開始している',
    26040033: 'このコンテナはアンバインド非対応',
    26040034: 'このコンテナは仕分けサブコンテナではない',
    26040035: '梱包中・梱包待ちの仕分けコンテナのみ異常を提出できる',
    26040036: 'このコンテナはすでにバインドされている',
    26040037: 'ピッキングサブコンテナが見つからない',
    26060001: '出荷審査伝票はすでに存在する',
    26060002: '出荷審査伝票が存在しない',
    26060005: '審査伝票はすでに完了しているため、再審査は不要',
    26060006: '出荷伝票はキャンセルされているため、審査は不要',
    26060007: 'この伝票以外、この種類の伝票には審査が必要なものはない',
    26060009: '該当商品情報なし',
    26060010: 'この受取国で利用可能な貨物代行会社が変更されました。リフレッシュしてください',
    26060011: '審査伝票の状態はすでに「確認待ち」または「処理済み」であり、異常変更不可',
    26060012: '審査伝票はすでに確認されている',
    26060013: '審査伝票ステータス変更済み',
    26060014: '商品の輸送属性に対応する異常理由がないため、再確認してください',
    26090001: '該当設定はすでに存在します。',
    26090002: '該当設定なし',
    26090003: '該当設定は既に存在します。検索して編集してください。',
    26090004: '一台のコンピュータには同じサイズのプリンタを一台だけ設定できます。',
    26090005: '仕分けコンテナが上限を超えています。',
    26090006: '該当庫位が見つかりません。',
    26090007: 'テンプレート設定データが見つかりません。',
    26090008: 'テンプレート設定順序が複数存在します。',
    26100001: '入庫番号の作成に失敗しました。',
    26100006: '入庫番号の仕入情報が存在しません',
    26100008: '欠品の異常処理数が残りの処理可能数を超えました',
    26100009: '入庫数量が仕入れ数量に達していないため、複数件のリクエストを送信することは禁止されます。',
    26100011: '欠品の提出に失敗しました。',
    26100013: '入庫番号が未受領のため、受領してください',
    26100016: '該当伝票番号に関する異常記録はありません',
    26100017: 'レベルを選択してください',
    26100018: 'レベルコード異常',
    26100019: '該当商品の入庫は未完成のため、複数件の入庫はできません',
    26100022: '関連する欠品異常は存在していません',
    26100023: '入庫数量が上限超過、または処理済み',
    26100024: '箱ラベル番号が重複しています。追跡番号をスキャンしてください',
    26110001: '業務担当が処理完了になったため、画像を変更することはできません',
    26110002: '不正なイベントタイプ値が入力された',
    26110003: '不正なイベントタイプ値が入力されており、状態に変換できない',
    26110004: 'イベントID必須入力',
    26110005: '不正差止状態値が入力されており、状態に変換できない',
    26110006: 'この出荷伝票はすでにせき止めされています。別途保管してください',
    26110007: 'この出荷伝票はすでにせき止めされているため、ピッキングタスクを生成できない',
    26110008: '審査理由が指定された範囲外',
    26140002: '調整後の数量は元の数量と一致にはできません',
    26150001: '貨物代行会社が一致しないため、リフレッシュしてください',
    26150002: 'すでに梱包が完了した出荷伝票があります。ページデータをリフレッシュしてください',
    26160001: '入庫番号が間違っています',
    26160002: 'ラベルの貼り直しが必要です。パソコンで入庫操作を行ってください。',
    26160003: '以下の商品はラベルの貼り直しが必要です。パソコンで入庫操作を行ってください：{0}',
    26160004: '現在の倉庫エリアに移庫待ちの商品はありません',
    26160005: '既に受領された入庫番号はキャンセルできません',
    26160006: '入庫番号はキャンセル済みのため、入庫できません',
    26160007: '一部の商品データが変更されました。再度スキャンしてください',
    26160008: '入庫番号はキャンセル済みのため、受領できません',
    26160009: '入庫番号が未受領のため、受領してください',
    26160010: '該当のステータスにはすでに存在しますので、重複して作成しないでください',
    26170001: '商品データが重複しています',
    26170002: '商品データが不完全です',
    26170003: '無効なファイルはインポートできません',
    26170004: 'SKUコード重複',
    26170005: 'ファイル行数が100,000行の制限を超えている',
    26170006: '非対応ファイルフォーマット。対応されているフォーマット：txt, csv, xls, xlsx',
    26170007: '運送伝票番号はすでに使用されているため、削除不可',
    26170011: 'すべての入庫伝票が入庫完了しました',
    26170012: 'このSKUはすべて検品済み、他のSKUをスキャンしてください',
    26170014: '厚さと三辺の合計を入力してください​',
    26170015: '出荷伝票はすでに運賃が差し引かれているため、送り状番号を変更できません。',
    27000000: '在庫変更に失敗しました',
    27000001: '利用可能な在庫が不足しています',
    27000002: '操作タイプ異常',
    27000003: 'この操作タイプはサポートされていません',
    27000004: '該当在庫なし',
    27000005: '在庫コンテナまたは庫位を空にすることはできません',
    27000006: '在庫ロック機能異常',
    28010010: '物流システムには存在しません',
    220101015: '注文書は未承認で完了しており、一時的に優先的に出荷することはできません',
    220101019: 'ブランドライセンス未取得のため、発注できません',
    240000012: 'ブラックリストに載っている商品は仕入れできません',
    240000014: '卸売最小ロット数未達、手動発注必要、右側の発注ボタンをクリックしてご確認下さい',
    240000015: '一括分納発送を行う注文は最大200件までです',
    240000016: '選択された注文は分納発送できません',
    240000017: 'すでにバッチ処理中です。分納発送をご希望の場合は、注文を個別に処理して下さい',
    240000020: 'データが更新されたため、オプションを再編集する必要があります',
    240000035: 'エラーが発生しました。洗濯タグ仕様が設定されていません',
    241000001: '発注不可：現在ご利用中の店舗では、「CKB Choice」商品を購入することはできません。',
    260000000: '出荷タスクのパラメータ無効',
    260000001: '出荷タスクのステータス更新失敗',
    260000002: '出荷タスクのデータ更新失敗',
    260000003: '出荷情報取得不可：データなし',
    260000110: '仕分けボックスの未使用数が不十分で、割当できない',
    260001391: '国際出荷伝票の通貨と決済通貨が一致しない',
    '-1': 'エラーあり カスタマーサービスへご連絡下さい',
    '26010019-1': '一部のロットは該当倉庫エリアに移動できません。この部分のロットはページからキャンセルされました：{0}',
    '26040001-1': 'コンテナのプレフィックスはすでに存在する',
    '10008_1': '入庫数が入庫番号の商品総数を超えています',
    '26000010-1': '運送番号{0}で計算された運賃が0です。経理部門に連絡してください',
    '26000010-2': '運賃ルールの検証異常：{0}',
    '26000017-1': '当の荷物の重量が上限を超過する',
    '26000018-1': '当の箱の商品金額が上限を超過する',
    '26000018-2': '当の荷物の商品金額が上限を超過する',
    '26000025-1': '異常なロケーションに複数の国際出荷伝票がある。データ異常',
    '26000064-1': '{0}フォワーダー利用不可',
    '26000064-2': '一律料金の注文は物流変更不可',
    '26000075_1': '通関住所情報なし',
    '26000099-1': '選択{0}フォワーダーは物流APIタイプが設定されていません。(移動先：設定 -> 物流API関連設定ページ)',
    '26000099-2': '選択フォワーダーには対応する国際運賃ルールが設定されていません。他のチャネルを選択するか、経理部門に設定を依頼してください',
    '26000099-3': '選択フォワーダー:{0}には対応する国際運賃ルールが設定されていません。他のチャネルを選択するか、経理部門に設定を依頼してください',
    '26000134-1': '該当する物流追跡番号が見つからない',
    '26000137-1': '顧客IDなし',
    '26020031-1': '長さ、幅、高さの制限[1~1000]cm',
    '26040021-1': '当のユーザーは複数のピッキングコンテナをバインドしています。先にアンバインドしてください',
    '26040021-2': '当のユーザーがバインドしているコンテナ: {0}',
    '26040021-3': '当のバッチは他のコンテナにバインドされている: {0}',
    '26060013-1': '審査伝票はすでにキャンセルされているため、リフレッシュしてください',
    '26060013-2': '審査伝票の一部SKUはすでにキャンセルされているため、リフレッシュしてください',
    '-3': '出荷タスク番号は必須入力項目です。',
    20000018: 'API注文はすべて失敗しました。商品に異常があります。',
    20000019: 'API注文は一部失敗しました。商品に異常があります。',
    26170008: '日本郵便のみ対応しております',
    26170009: '有効な伝票番号が存在しません。',
    26170010: '荷物仕分番号の取得に失敗しました。',
    26170013: 'フォーマットエラー：特殊文字が含まれています。'
  }
}
